import styled from "@emotion/styled"
import {
  Answer,
  NumberAnswerData,
  QuestionData,
  RadioAnswerData,
} from "../config/questions"
import { breakPoints } from "../config/theme"
import { NumberAnswer } from "./NumberAnswer"
import { RadioAnswer } from "./RadioAnswer"
import { Title } from "./Title"

const Base = styled.div``

const Answers = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
  justify-items: center;
  align-items: center;
  gap: 24px;
  margin-top: 40px;
  margin-bottom: 20px;

  > * {
    grid-column: span 2;
  }

  // If there are at least 4 items, align them into 2 cols
  & > :nth-last-of-type(n + 4),
  & > :nth-last-of-type(n + 4) ~ * {
    grid-column: span 1;
    width: 100%;

    @media only screen and (max-width: ${breakPoints.tablet}) {
      grid-column: span 2;
      width: inherit;
    }
  }

  @media only screen and (max-width: ${breakPoints.mobile}) {
    margin-top: 16px;
    margin-bottom: 16px;
    gap: 16px;
    width: 100%;
  }
`

type QuestionProps = {
  question: QuestionData
  onChangeAnswer: (newAnswer: Answer) => void
}

export const AnswerComponent: React.FC<{
  question: QuestionData
  onChangeAnswer: (newAnswer: Answer) => void
}> = ({ question, onChangeAnswer }) => {
  switch (question.answer.type) {
    case "number":
      return (
        <>
          <NumberAnswer
            {...question.answer}
            isValid={question.answer.validate()}
            onChange={(value) => {
              const newAnswer = { ...question.answer } as NumberAnswerData
              newAnswer.value = value
              onChangeAnswer(newAnswer)
            }}
          />
        </>
      )
    case "radio":
      return (
        <>
          {question.answer.options.map((option, i) => (
            <RadioAnswer
              label={option.text}
              selected={option.selected}
              key={`r-${question.number}-${i}`}
              onClick={() => {
                const newAnswer = { ...question.answer } as RadioAnswerData
                newAnswer.options.forEach((o) => (o.selected = false))
                newAnswer.options[i].selected = true
                onChangeAnswer(newAnswer)
              }}
            />
          ))}
        </>
      )
    case "select":
      // TODO add select
      return <>SELECT TODO {JSON.stringify(question.answer.options)}</>
  }
}

export const Question: React.FC<QuestionProps> = ({
  question,
  onChangeAnswer,
}) => (
  <Base>
    <Title key={question.number}>{question.text}</Title>
    <Answers>
      <AnswerComponent question={question} onChangeAnswer={onChangeAnswer} />
    </Answers>
  </Base>
)
